import React, {useState} from 'react'
import { MyOrderWrap, TitleWrap } from './styles'
import OrderHistory from '../../../components/list/OrderHistory'
import RealOrderHistory from '../../../components/list/RealOrderHistory'

import LineTab from '../../../components/tab/LineTab'

const MyOrder = () => {
  const [tabActive, setTabActive] = useState(0)
  const handleChangeTab = (i: number) => {
    setTabActive(i)
  }

  return (
    <MyOrderWrap>
      <TitleWrap>
        <h2>주문내역</h2>
      </TitleWrap>
      <div className="tab-wrap">
        <LineTab
          tabList={['상품', '상품권']}
          handleChange={handleChangeTab}
        />
      </div>
      {
        tabActive ? <OrderHistory/> : <RealOrderHistory/>
      }

    </MyOrderWrap>
  )
}

export default MyOrder
